import { FC } from 'react'

import {
  BorderRadius6,
  GreyGrey10,
  GreyGrey90,
  IndigoIndigo60,
  Primary13SemiBold,
  Grid,
  GridItem
} from '@sequencehq/core-components'

export const ExternalAccountDetails: FC<{
  name: string
  externalUrl: string
  serviceName: string
}> = ({ name, externalUrl, serviceName }) => {
  return (
    <Grid
      gridTemplateColumns="1fr auto"
      gridColumnGap="8px"
      backgroundColor={GreyGrey10}
      borderRadius={BorderRadius6}
      padding="12px"
    >
      <GridItem
        {...Primary13SemiBold}
        color={GreyGrey90}
        data-testid="customerLinking.details.name"
      >
        {name}
      </GridItem>
      <GridItem {...Primary13SemiBold} color={IndigoIndigo60}>
        <a
          href={externalUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="customerLinking.details.link"
        >
          View in {serviceName}
        </a>
      </GridItem>
    </Grid>
  )
}
